module.exports = __webpack_public_path__ + "static/media/tip_text_dog_twelveweek_fr.6f191e17.svg";